<template>
    <div class="workorderInfromation">
        <div class="workorderInfromation_title">
            <div class="workorderInfromation_t_zhzx" :class="{'QZX':timeLineData.roleGrade=='1','ZLD':timeLineData.roleGrade=='2','ZGLD':timeLineData.roleGrade=='4','ZX':timeLineData.roleGrade=='3'}">
                {{timeLineData.czCzdwmc}}
            </div>
            <div class="workorderInfromation_t_name">
                <!--<span class="icon-leader"><span class="path1"></span><span class="path2"></span></span>-->
                {{timeLineData.czCzrmc}}
            </div>
            <div class="workorderInfromation_t_describe">
                改派工单至
            </div>
            <div class="workorderInfromation_t_pfgdToUnit">
                {{timeLineData.czFpcbdwmc}}
            </div>
            <div class="workorderInfromation_t_mainResponse" v-if="timeLineData.czFpsfzz=='1'">
                主责
            </div>
        </div>
        <div class="workorderInfromation_progressTime">
            <span class="icon-time_fill workorderInfromation_icon"></span>
            <div class="workorderInfromation_p_time">
                {{timeLineData.czCzsj}}
            </div>
            <div class="workorderInfromation_p_day">
                第{{timeLineData.theDay}}天
            </div>
        </div>
        <div class="workorderInfromation_option">
            <span class="icon-hourglass workorderInfromation_icon"></span>
            <div>
                <span class="workorderInfromation_option_label">处理时限：</span>{{timeLineData.czFpclsx}}
            </div>
        </div>
        <div class="workorderInfromation_option">
            <span class="icon-alarmClock workorderInfromation_icon"></span>
            <div>
                <span class="workorderInfromation_option_label">截止时间：</span>{{timeLineData.czFpdxjzrq}}
            </div>
        </div>
        <div class="workorderInfromation_option">
            <span class="icon-progress workorderInfromation_icon"></span>
            <div>
                <span class="workorderInfromation_option_label">处理意见：</span>{{timeLineData.czCzjgwb}}
            </div>
        </div>
        <div class="workorderInfromation_line" v-if="timeLineData.files && timeLineData.files.length>0">

        </div>
        <TimeLine_file :files="timeLineData.files" v-if="timeLineData.files && timeLineData.files.length>0"></TimeLine_file>
    </div>
</template>

<script>
    import {reactive, ref, getCurrentInstance, onMounted, inject} from 'vue'
    import TimeLine_file from "./TimeLine_file.vue"
    export default {
        name: "TimeLine_GDGP",
        props:["timeLineList"],
        components: {
            TimeLine_file
        },
        setup(props, context) {
            // let gdId = inject("gdId");
            // let timeLineData = reactive({
            //     "czCzdwmc": "指挥中心",//处置单位名称
            //     "czFpsfzz" : "1" , //是否主责(1是、0否)
            //     "czCzsj": "2021.12.02 14:11:38", //处置时间
            //     "czCzjgwb":"未解决、不满意",
            //     "theDay": "1", //第n天"
            //     "czFpclsx" : "1自然日", //处理时限
            //     "czFpdxjzrq" : "2021.12.02 14:11:38", //截止时间
            // })
            let timeLineData = props.timeLineList;
            return {
                timeLineData
            }
        }
    }
</script>

<style scoped>

</style>
